import { autoEnrolamientoComponent } from './components/autoEnrolamiento/autoEnrolamiento.component';
import { DashboardAutoridadesComponent } from './components/dashboard-autoridades/dashboard-autoridades.component';
import { HomeComponent } from './components/home/home.component';
import { Principal } from './components/principal/principal.component';
import { ContainerComponent } from './components/contenedor/container.component';
import { LoginComponent } from './components/login/login.component';
import { AuthGuard } from './commons/guards/Auth.guard';
import { OrganosComponent } from './commons/components/organos/organos.component';
import { altaUsuarioComponent } from './components/altaUsuario/altaUsuario.component'
import { ChangePassIniComponent } from './components/login/cambioPassInicial/changePassIni.component';
import { recuperarPasswordComponent } from './components/recuperarPassword/recuperarPassword.component';
import { Reporte } from './components/rep-sol-alta-itx-ip/dictaminacion/reporte/reporte';
import { ValidarSolicitudComponent } from './components/autoEnrolamiento/validarSolicitud/validarSolicitud.component';
import { DocumentoComponent } from './components/login/AceptacionAutoridad/documento-component/documento-component';
import { UtilsAdminComponent } from './components/utilsAdmin/utilsAdmin.component';
import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'reestablecerPass/:_Codigo/:_Usuario', component: recuperarPasswordComponent },
    { path: 'reestablecerPass', component: recuperarPasswordComponent },
    { path: 'autoEnrolamiento', component: autoEnrolamientoComponent },
    { path: 'validarSolicitudAutoEnrolamiento', component: ValidarSolicitudComponent },
    { path: 'validarSolicitudAutoEnrolamiento/:_guid', component: ValidarSolicitudComponent },
    {

        path: '', component: Principal, canActivate: [AuthGuard], children: [

            {
                path: 'home',
                component: HomeComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'itx/:Idpantalla',
                component: ContainerComponent,
                canActivate: [AuthGuard]
            }
        ]
    },
    {
        path: 'ChangeCourt/:isChange',
        component: OrganosComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'ChangePassIni',
        component: ChangePassIniComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'SelectCourt',
        component: OrganosComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'RegistrarUsuarios',
        component: altaUsuarioComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'ReporteAltaInstitucionesPublicas',
        component: Reporte,
        canActivate: [AuthGuard]
    },
    {
        path: 'AvisoPrivacidad',
        component: DocumentoComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'AutoridadesInterconectadas',
       component: DashboardAutoridadesComponent
    },
    {
        path: 'utilsAdmin',
        component: UtilsAdminComponent
    }
];